module.exports = __webpack_public_path__ + "static/media/winner-board.0383e00e.png";